export enum NutritionistOrganizationSnapshotSegments {
  Snapshot = ':snapshotKey'
}

export enum NutritionistOrganizationResource {
  Profiles = 'profiles',
  AvailabilitySnapshots = 'availability-snapshots',
  AvailabilitySnapshotView = `availability-snapshots/${NutritionistOrganizationSnapshotSegments.Snapshot}`
}
